
export default {
  // Airports
  "airports": "空港",
  "search_airports": "空港を検索",
  "no_airports_found": "空港が見つかりません",
  "try_different_search": "別の検索条件をお試しください",
  "add_review": "レビューを追加",
  "all_airports": "すべての空港",
  "top_rated": "高評価",
  "film_friendly_score": "フィルムフレンドリースコア",
  "film_friendly": "フィルムフレンドリー",
  "not_film_friendly": "フィルムフレンドリーではない",
  "average_score": "平均スコア",
  "hand_check_success_rate": "手動チェック成功率",
  "reviews_count": "レビュー数",
  "add_to_favorites": "お気に入りに追加",
  "remove_from_favorites": "お気に入りから削除",
  "no_reviews_yet": "まだレビューがありません",
  "be_first_review": "最初のレビューを書いてください！",
  "nearby_airports": "近くの空港",
  "other_airports": "その他の空港",
  "distance_away": "離れている",
  "film_scanner_types": "フィルムスキャナータイプ",
  "ct_scanner": "CTスキャナー",
  "x_ray_scanner": "X線スキャナー",
  "handheld": "ハンドヘルド",
  "metal_detector": "金属探知機",
  "security_notes": "セキュリティノート",
  "hand_check_policy": "手動チェックポリシー",
  "allowed": "許可",
  "sometimes": "場合による",
  "not_allowed": "許可されていない",
  "unknown": "不明",
  "rating": "評価",
  "ratings": "評価",
  "airport_not_found": "空港が見つかりません",
  "cant_find_airport": "お探しの空港が見つかりません。",
  "report_missing_airport": "不足している空港を報告する",
  "show_map": "地図を表示",
  "hide_map": "地図を非表示"
};
